import { combineReducers } from 'redux'

import transactionReducer from './transaction/transaction.reducer'
import userReducer from './user/user.reducer'
import loadingReducer from './loading/loading.reducer'
import errorReducer from './error/error.reducer'
import cloudCertModalReducer from './cloud-cert-modal/cloud-cert-modal.reducer'
import validationReducer from './validate-document/validate-document.reducer'
import verifyCredabilityReducer from './verify-document-credability/verify-document-credability.reducer'
import tspReducer from './tsp/tsp.reducer'
import pdfReportReducer from './pdf-report/pdf-report.reducer'

const rootReducer = combineReducers({
  transaction: transactionReducer,
  currentUser: userReducer,
  loading: loadingReducer,
  error: errorReducer,
  cloudCertModal: cloudCertModalReducer,
  validation: validationReducer,
  verifyCredability:  verifyCredabilityReducer,
  tsp: tspReducer
})

export default rootReducer